export const PASSWORD_REGEX = {
  lowercase: /[a-z]/,
  uppercase: /[A-Z]/,
  number: /[0-9]/,
  minLength: /.{8,}/,
  special: /[!@#$%^&*(),.?":;{}_|<>=/+-]/,
};
